
import React from 'react'
import {Edit3, Eye} from 'lucide-react'

interface EditModeToggleProps {
  isEditMode: boolean
  onToggle: () => void
  size?: 'sm' | 'md' | 'lg'
}

const EditModeToggle: React.FC<EditModeToggleProps> = ({ 
  isEditMode, 
  onToggle, 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
  }

  const iconSizes = {
    sm: 14,
    md: 16,
    lg: 18
  }

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    console.log('EditModeToggle clicked, current isEditMode:', isEditMode)
    
    if (typeof onToggle === 'function') {
      onToggle()
    } else {
      console.error('onToggle is not a function:', onToggle)
    }
  }

  return (
    <button
      onClick={handleToggle}
      type="button"
      className={`
        ${sizeClasses[size]}
        ${isEditMode 
          ? 'bg-orange-600 hover:bg-orange-700 text-white' 
          : 'bg-blue-600 hover:bg-blue-700 text-white'
        }
        rounded-lg font-medium transition-all duration-200 
        flex items-center space-x-2 shadow-lg hover:shadow-xl
        border-2 border-white/20 backdrop-blur-sm
        focus:outline-none focus:ring-2 focus:ring-white/50
      `}
      title={isEditMode ? '보기 모드로 전환' : '편집 모드로 전환'}
    >
      {isEditMode ? (
        <>
          <Eye size={iconSizes[size]} />
          <span>보기 모드</span>
        </>
      ) : (
        <>
          <Edit3 size={iconSizes[size]} />
          <span>편집 모드</span>
        </>
      )}
    </button>
  )
}

export default EditModeToggle
